import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as spaceFunctions from '../../../../space-functions'
import * as entry from '../entry'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: entry.RESOURCE.payload.dimension.partialId,
      partialId: entry.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Associated functional usage',
    isOptional: false,
    name: 'Space Functional Usage',
    partialId: PartialId.Standard.create('func_space'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(
        spaceFunctions.RESOURCE.payload,
      ),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
